<template>
  <v-container>
    <v-row justify="center">
      <v-col :cols="12" :sm="9" :md="10" :lg="9" :xl="8">
        <v-card class="pb-5 pt-1 pl-1" flat
          ><span
            style="font-family: explorerTitleFont;font-size:20px;font-weight:600;"
            >Addresses</span
          ></v-card
        >
        <expand-table
          :prop-limit="limit"
          :apiUrl="apiUrl"
          :links="links"
          :attributes="attributes"
          :order="order"
          :subtile="subtile"
          class="pt-0"
          :infiniteLoading="true"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ExpandTable from "../material/ExpandTable.vue";
import { mapState } from "vuex";
export default {
  components: {
    ExpandTable
  },
  data() {
    return {
      attributes: [
        { text: "Address", value: "address" },
        { text: "Balance", value: "balance" }
      ],
      subtile: {
        address: { type: "text", text: "Address", mobileHidden: true },
        balance: {
          type: "transform_unity",
          text: "Balance",
          mobileHidden: true,
          align: "right"
        },
        updatedAt: { type: "time_ago", text: "Active Status" },
        transactionCount: {
          type: "thousands",
          text: "Transaction Count"
        }
      },
      order: ["updatedAt", "transactionCount"],
      limit: 10,
      apiUrl: "",
      links: {
        address: "/address/:address"
      }
    };
  },
  computed: {
    ...mapState(["tokenId"])
  },
  created() {
    this.apiUrl = `${this.$config.apiEndPoint}/token/${this.tokenId}/addresses`;
    if (this.$config.version === "basic") {
      this.$delete(this.subtile, "updatedAt");
      this.$delete(this.subtile, "transactionCount");
    }
  }
};
</script>
<style>
@font-face {
  /* font-properties */
  font-family: explorerTitleFont;
  src: url("../../assets/font/SF-Pro-Display-Semibold.otf");
}
</style>
>
